export default function Navbar() {
    return (
      <div className="navbar">
        🩺 Smart Video Vitals Scanner
      </div>
    );
  }
  